import { render, staticRenderFns } from "./RecentPagePdfButton.vue?vue&type=template&id=01885c6e"
import script from "./RecentPagePdfButton.vue?vue&type=script&lang=js"
export * from "./RecentPagePdfButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports